import React, { useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { InputCheckBox, Box } from '@itandi/itandi-bb-ui';
import { DealSearchCondition, SearchApplicationType } from '~/models/Deal';

type Props = {
  labelText: string;
  applicationType: SearchApplicationType;
  dealSearchCondition: DealSearchCondition;
};

export const ApplicationTypeCheckBox: React.FC<Props> = ({
  applicationType,
  labelText,
  dealSearchCondition
}: Props) => {
  const { setValue, getValues } = useFormContext<DealSearchCondition>();
  const { applicationTypes: applicationTypesFromParam } = dealSearchCondition;
  const defaultCheck = (): boolean => {
    if (applicationTypesFromParam) {
      return applicationTypesFromParam.includes(applicationType);
    }
    return false;
  };

  const [checked, setChecked] = useState<boolean>(defaultCheck);
  const onChangeApplicationType = React.useCallback((): void => {
    const applicationTypes = getValues('applicationTypes') || [];
    if (!checked) {
      // 追加
      if (!applicationTypes.includes(applicationType)) {
        applicationTypes.push(applicationType);
      }
    } else {
      // 削除
      applicationTypes.splice(applicationTypes.indexOf(applicationType), 1);
    }
    setValue('applicationTypes', applicationTypes);
    setChecked(!checked);
  }, [checked, applicationType, getValues, setValue]);
  return (
    <Box margin={4} minWidth={0}>
      <InputCheckBox
        checked={checked}
        labelText={labelText}
        onChange={onChangeApplicationType}
      />
    </Box>
  );
};
